import { render, staticRenderFns } from "./BusinessReferencesClassificationView.vue?vue&type=template&id=2ff28adc&scoped=true&"
import script from "./BusinessReferencesClassificationView.vue?vue&type=script&lang=ts&"
export * from "./BusinessReferencesClassificationView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessReferencesClassificationView.vue?vue&type=style&index=0&id=2ff28adc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff28adc",
  null
  
)

export default component.exports